<template>
  <div>
    <div>
      <div class="d-flex flex-row mb-2 justify-space-between">
        <div class="">
          <img src="../../../public/static/emblem.png" alt="Emblem Of Nepal" style="width: 100px">
        </div>
        <div class="text-center">
          <div class="text-subtitle-2 font-weight-medium">Government of Nepal</div>
          <div class="text-subtitle-2 font-weight-medium">Ministry of Home Affairs</div>
          <div class="text-subtitle-1 font-weight-bold">Department of Immigration</div>
          <div class="text-caption font-weight-medium">Kathmandu, Nepal</div>
        </div>
        <div class="">
          <img
              :src="`data:image/png;base64, ${visaRequest.qrcode_image}`"
              alt="Qr Code"
              style="width: 100px"
          />
        </div>
      </div>

      <div>
        <div class="text-h5 text-center font-weight-bold text-decoration-underline mb-3">
          Electronic Travel Authorization (eTA)
        </div>
        <div class="text-subtitle-2 font-weight-medium">
          Dear <strong>{{ visaRequest.traveller.full_name }}</strong> <br>
          Your application for Nepali e-Visa has been approved with following details:
        </div>
      </div>

      <div class="mt-1">
        <table style="width: 100%;">
          <tbody>
          <tr>
            <td><b>Submission No.:</b></td>
            <td><b>{{ visaRequest.submission_no }}</b></td>
          </tr>
          <tr>
            <td><b>Passport Number:</b></td>
            <td><b>{{ visaRequest.documents[0].number }}</b></td>
          </tr>
          <tr>
            <td><b>eTA Number:</b></td>
            <td><b>{{ visaRequest.visa_number }}</b></td>
          </tr>
          <tr>
            <td><b>Traveler Name:</b></td>
            <td><b>{{ visaRequest.traveller.full_name }}</b></td>
          </tr>
          <tr>
            <td><b>Nationality:</b></td>
            <td><b>{{ visaRequest.traveller.country.country_name }}</b></td>
          </tr>
          <tr>
            <td><b>Visa Type:</b></td>
            <td>
              <b>
                {{ visaRequest.visaType.name }}
                ({{ visaRequest.visa_type_condition.name }})
              </b>
            </td>
          </tr>
          <tr>
            <td><b>Visa Days:</b></td>
            <td><b>{{ visaRequest.duration }} Days</b></td>
          </tr>
          <tr>
            <td><b>Visa Plan (Plain/SRE/MRE):</b></td>
            <td><b>{{ visaRequest.visa_plan_name }}</b></td>
          </tr>
          <tr>
            <td><b>Issuing Authority:</b></td>
            <td><b>{{ visaRequest.approve_details.approved_by }}</b></td>
          </tr>
          <tr>
            <td><b>Issuing Date:</b></td>
            <td><b>{{ visaRequest.approve_details.approved_at }}</b></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="mt-4">
        <div class="font-weight-black text-subtitle-2">Note:</div>
        <ul class="font-italic">
          <li>This eTA is valid until <b>{{ validTill }}</b>, and the visa remains valid for the specified period mentioned
            above
            from the date of entry.
          </li>
          <li>Please bring a copy of this eTA with you when you arrive in Nepal for the first time.</li>
          <li>The aforementioned passport is a requirement for arrival.</li>
          <li>Upon arrival in Nepal, the applicant's biometric information will be taken at entry point.</li>
          <li>This electronic travel authorization does not necessarily guarantee your entry into Nepal. Even when you
            arrive you might be denied entry to the country.
          </li>
          <li>You can verify the status of this eTA by scanning the QR code.</li>
          <li>Validity of your passport/travel document should be at least 6 months at the time of entry into Nepal.
          </li>
        </ul>
      </div>
    </div>

    <div v-if="false">
      <h2>Sorry! This page is unavailable</h2>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  name: "EtaPrintContent",
  computed: {
    ...mapGetters("AuthUser", ["user"]),
    date() {
      return new Date().toISOString().substring(0, 10)
    },
    validTill() {
      if (this.visaRequest) {
        const {approved_at} = this.visaRequest.approve_details
        return moment(approved_at).add(6, 'M').format('YYYY-MM-DD')
      }
      return null;
    },
    visaRequest() {
      return this.$store.state.VisaRequestSingle.visaRequest
    },
  },
  methods: {}
}
</script>

<style scoped>
table, th, td {
  border: 1px solid black;
}

table {
  border-collapse: separate;
  border-spacing: 1px;
  border-left: 0;
  border-bottom: 0;
}

table tbody tr td:first-child {
  width: 35%;
}

td, th {
  border-top: 0;
  border-right: 0;
  padding: 5px;
}

.td-font-bold {
  font-weight: bold;
}

</style>
